// FILE: src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2B80B6", // light blue
      dark: "#0B212F", // dark blue
      light: "#0D3D51", // dark blue light
    },
    secondary: {
      main: "#2C6B8C", // middle blue
    },
    // You can add more custom colors if needed
    custom: {
      darkBlue: "#0B212F",
      darkBlueLight: "#0D3D51",
      middleBlue: "#2C6B8C",
      lightBlue: "#2B80B6",
    },
  },
  typography: {
    // Define your typography here if needed
  },
});

export default theme;